<template>
  <div class="mb-5">
    <v-tabs :value="selectedTab"
            class="rounded-lg white--text"
            background-color="secondary"
            active-class="primary"
            color="#FF8700">
      <v-tab @click="changeRoute(tab)" v-for="tab in tabs" class="white--text mr-2">{{tab.title}}</v-tab>
    </v-tabs>
  </div>
</template>

<script>
import {toString} from "lodash";

export default {
  name: "ChequeTabs",
  data() {
    return {
    };
  },
  props: {
    type: {
      default: 'receive'
    },
  },
  computed: {
    selectedTab(){
      if(this.$route.name == 'ChequeDetail' && toString(this.type) == 'false') {
        return 0
      }
      if(this.$route.name == 'ChequeForm' && toString(this.type) == 'false') {
        return 0
      }
      if(this.$route.name == 'ChequesList' && toString(this.type) == 'false') {
        return 1
      }
      if(this.$route.name == 'ChequeDetail' && toString(this.type) == 'true') {
        return 2
      }
      if(this.$route.name == 'ChequeForm' && toString(this.type) == 'true') {
        return 2
      }
      if(this.$route.name == 'ChequesList' && toString(this.type) == 'true') {
        return 3
      }
      if(this.$route.name == 'ChequebookForm') {
        return 4
      }
    },
    tabs() {
      return [
        {title: 'ثبت چک دریافتنی', key: 'form', type: false},
        {title: 'لیست چک های دریافتنی', key: 'list', type: false},
        {title: 'ثبت چک پرداختنی', key: 'form', type: true},
        {title: 'لیست چک های پرداختنی', key: 'list', type: true},
        {title: 'تعریف دسته چک', key: 'chequeBook', type: ''},
      ]
    },
  },
  methods: {
    changeRoute(tab){
      let keys = {list: '/report/lists/cheques/c/', form: '/panel/cheque/form/c/',
        chequeBook: '/panel/chequebooks'}
      this.$router.push(keys[tab.key] + tab.type)
    }
  }

};
</script>

<style scoped lang="scss">
</style>

